import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../api/axios";
import { DockStatus } from "./types";

// Single dock-status endpoint keyed by backend location id (the read is
// identical across robotics systems; location is the discriminator).
export const useDockStatus = (locationId: number) => {
  return useQuery({
    queryKey: ["dockStatus", locationId],
    queryFn: async () => {
      const response = await api.get<DockStatus>(`/docks/location/${locationId}`);
      return response.data;
    },
    refetchInterval: 15000,
  });
};
